import { render, staticRenderFns } from "./TrainingAvailable.vue?vue&type=template&id=2aff4110&scoped=true"
import script from "./TrainingAvailable.vue?vue&type=script&lang=js"
export * from "./TrainingAvailable.vue?vue&type=script&lang=js"
import style0 from "./TrainingAvailable.vue?vue&type=style&index=0&id=2aff4110&prod&lang=scss"
import style1 from "./TrainingAvailable.vue?vue&type=style&index=1&id=2aff4110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff4110",
  null
  
)

export default component.exports